// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__IKiJs","logo":"styles_logo__lscBD","ticker":"styles_ticker__-pWvo","bone-skeleton":"styles_bone-skeleton__a3bDF"};